import type { TrainingLessonSpecific } from './trainingLessonUi';

export const priest1DutiesEn: TrainingLessonSpecific = {
  intro:
    'A priest has special responsibilities: bless and pass the sacrament, baptize (when assigned), and serve with dignity. An ordinance is not mechanical; preparation changes the experience for those who receive.',
  objectives: [
    'Understand priest responsibilities.',
    'Prepare worthily to bless/pass the sacrament.',
    'Differentiate the priest’s role from other offices.',
    'Learn spiritual preparation before officiating.',
    'Build habits of reverence when officiating.',
  ],
  briefHeading: 'The priest in brief',
  briefBody:
    'A priest administers the sacrament, may baptize when delegated, and officiates reverently. His example and preparation help members feel the Spirit in each ordinance.',
  scriptures: [
    { ref: 'D&C 20:46–52', text: 'Priest duties: preach, teach, baptize, administer the sacrament.' },
    { ref: 'D&C 13', text: '…the keys of the ministering of angels, and of the gospel of repentance…' },
    { ref: '3 Nephi 18:1–7', text: 'The sacrament: remember the Savior.' },
    { ref: 'D&C 84:33–39', text: '…all those who receive the priesthood receive me…' },
    { ref: 'Hebrews 5:4', text: '…no man taketh this honour unto himself, but he that is called of God…' },
  ],
  didYouKnow: [
    'The ordinance is not “mechanical”; dignity matters.',
    'Preparation changes the experience for those who receive.',
  ],
  practiceItems: [
    'Pray before the meeting to prepare spiritually',
    'Review the sacrament prayers (D&C 20:77, 79)',
    'Arrive early to coordinate with whoever presides',
    'Review posture and tone of voice when officiating',
    'Coordinate with whoever presides at sacrament meeting',
    'Brief self-review after the meeting: what will I improve?',
  ],
  reflectionQuestions: [
    'What habit should I correct to officiate with more dignity?',
    'How do I prepare better before blessing or passing the sacrament?',
    'What do I feel when I serve in this ordinance?',
  ],
  actionText: 'Prepare the sacrament as if it were for Christ.',
};
